<template>
  <button
    :class="[
      'hidden lg:flex items-center justify-center cursor-pointer w-12.5 aspect-square rounded-full border border-pink shrink-0 hover:border-dustrose hover:text-burgundy hover:bg-dustrose transition-[background-color_color_border] group',
      { 'rotate-180': reverse },
    ]"
  >
    <IconSprite id="arrow" class="group-hover:ml-1 transition-[margin]" />
  </button>
</template>

<script lang="ts">
import IconSprite from '@/components/helpers/IconSprite.vue'

export default {
  name: 'ArrowButton',
  components: { IconSprite },
  props: {
    reverse: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
